export default __webpack_public_path__ + "static/City_Manchester-f7d13d188b6ee529ab47e6c610cf01f8.jpeg";